<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
          :src="require('@/assets/images/logo/secondary-logo.png')"
          class="rounded mr-2"
          height="30"
          width="150"
          alt="Toast image"
        />
      </b-link>
      <!-- /Brand logo-->
      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            Reset Your Password
          </b-card-title>
          <b-card-text class="mb-2">
            Please reset your password that you remember.
          </b-card-text>
          <!-- form -->
          <validation-observer ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- password -->
              <b-form-group label="Password" label-for="reset-password">
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="form.password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="New Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group
                label="Confirm Password"
                label-for="confirm-reset-password"
              >
                <validation-provider
                  #default="{ errors }"
                  name="confirm Password"
                  vid="confirm Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="confirm-password"
                      v-model="form.confirmPassword"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="confirm-password"
                      placeholder="Confirm Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <p v-if="!isCorrect" class="text-danger">
                  Confirm password must match with new password.
                </p>
                <p v-if="!isLengthCorrect" class="text-danger">
                  Invalid pasword. Password length should be minimum of 5 digit.
                </p>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Reset Password
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>

      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BOverlay,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
// import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import useJwt from "@/auth/jwt/useJwt";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { jwtDecode } from "jwt-decode";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],

  data() {
    return {
      SERVICE_KEY: process.env.VUE_APP_SERVICE_KEY,
      isCorrect: true,
      isLengthCorrect: true,
      isLoading: false,
      form: {
        token: this.$route.query.token,
        password: "",
        confirmPassword: "",
      },

      isForgotPassword: false,
      status: "",
      sideImg: require("@/assets/images/pages/new-banner.svg"),
      // validation rules
      required,
      email,
    };
  },

  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/new-banner.svg");
        // this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  created() {
    const decoded = jwtDecode(this.$route.query.token);
    let exp = decoded.exp * 1000;
    if (new Date(exp) - new Date() < 0) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "EditIcon",
          variant: "danger",
          text: "Password Reset Link Expired.",
        },
      });
      this.$router.push({ path: "login" });
    }
  },
  methods: {
    login() {
      if (this.form.password !== this.form.confirmPassword) {
        this.isCorrect = false;
        this.isLengthCorrect = true;

        return false;
      } else if (this.form.password.length < 5) {
        this.isLengthCorrect = false;
        this.isCorrect = true;
        return false;
      } else {
        this.isCorrect = true;
        this.isLengthCorrect = true;
      }
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          // eslint-disable-next-line no-undef
          this.isLoading = true;

          axios
            .post("/api/V1.0/Token/GetToken", {
              serviceKey: this.SERVICE_KEY,
            })
            .then((res) => {
              //console.log(`client token: ${JSON.stringify(res)}`);
              axios
                .post("/User/api/V1.0/Password/ResetForgotPassword", this.form)
                .then((response) => {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Password Reset Success",
                      icon: "EditIcon",
                      variant: "success",
                      text: "Your password is reset successfully.",
                    },
                  });
                  this.$router.push({ path: "login" });
                  this.$store.dispatch("permission/handlePermission", response);
                  this.isLoading = false;
                  navigator;
                })
                .catch((res) => {
                  this.isLoading = false;
                  if (res.status === 400) {
                    this.isLoading = false;
                    this.$toast({
                      component: ToastificationContent,
                      position: "top-right",
                      props: {
                        title: "Error",
                        icon: "BellIcon",
                        variant: "danger",
                        text: `${res.data.errors.Password[0]}`,
                      },
                    });
                  } else {
                    this.isLoading = false;
                    this.$toast({
                      component: ToastificationContent,
                      position: "top-right",
                      props: {
                        title: "Error",
                        icon: "BellIcon",
                        variant: "danger",
                        text: `${res.data.message}`,
                      },
                    });
                  }
                });
            })
            .catch((error) => {
              this.isLoading = false;
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: `${error.data.message}`,
                },
              });
            });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
